const loadView = function(path) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${path}.vue`);
}

exports.loadView = loadView